// Single import site for the active race. To retarget the whole app, point this
// at a different race file (and nothing else changes).
import type { RaceConfig } from '../types/config.ts';
import { miSenDemPrimary2026 } from './races/mi-2026-sen-dem-primary.ts';

export const raceConfig: RaceConfig = miSenDemPrimary2026;
